import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import { chain, LoadRealTimeInventory } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListLines";

replaceInChain(chain, LoadRealTimeInventory, props => {
    const { wishListLines, productInfosByWishListLineId, replacementProductInfosByWishListLineId } = props;
    if (!wishListLines?.length) {
        props.inventoryLoaded = true;
        return;
    }

    const wishListLineIds = Object.keys(productInfosByWishListLineId);
    const productIds = wishListLineIds.map(o => productInfosByWishListLineId[o]!.productId);
    const replacementProductIds = wishListLineIds
        .map(o => replacementProductInfosByWishListLineId[o]?.productId)
        .filter((x): x is string => !!x);

    props.dispatch(
        loadRealTimeInventory({
            productIds: productIds.concat(replacementProductIds),
            expand: ["warehouses"], // Poolcorp Custom Code
            onComplete: realTimeInventoryProps => {
                if (realTimeInventoryProps?.error) {
                    wishListLineIds.forEach(o => {
                        const productInfo = productInfosByWishListLineId[o]!;
                        if (productInfo) {
                            productInfo.failedToLoadInventory = true;
                        }

                        const replacementProductInfo = replacementProductInfosByWishListLineId[o]!;
                        if (replacementProductInfo) {
                            replacementProductInfo.failedToLoadInventory = true;
                        }
                    });
                } else {
                    realTimeInventoryProps?.apiResult?.realTimeInventoryResults?.forEach(inventory => {
                        wishListLineIds.forEach(o => {
                            const productInfo = productInfosByWishListLineId[o]!;
                            if (productInfo.productId === inventory.productId) {
                                productInfo.inventory = inventory;
                            }

                            const replacementProductInfo = replacementProductInfosByWishListLineId[o]!;
                            if (replacementProductInfo && replacementProductInfo.productId === inventory.productId) {
                                replacementProductInfo.inventory = inventory;
                            }
                        });
                    });
                }

                props.inventoryLoaded = true;
            },
        }),
    );
});